(() => {
  if (window.randCardsProductCardLoaded) return;
  window.randCardsProductCardLoaded = true;

  const variantSelectSelector = '[data-rc-card-variant-select]';

  const findPriceTemplate = (card, variantId) =>
    Array.from(card.querySelectorAll('[data-rc-card-price-template]')).find(
      (template) => template.dataset.rcCardPriceTemplate === variantId
    );

  const updateCardVariant = (select) => {
    const card = select.closest('[data-rc-product-card]');
    const form = select.closest('form');
    const option = select.options[select.selectedIndex];

    if (!card || !form || !option) return;

    const variantId = option.value;
    const variantInput = form.querySelector('input[name="id"]');
    const variantUrl = option.dataset.url;
    const condition = option.dataset.condition || '';
    const conditionCode = option.dataset.conditionCode || '';

    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = false;
    }

    if (variantUrl) {
      card.querySelectorAll('[data-rc-card-link]').forEach((link) => {
        link.setAttribute('href', variantUrl);
      });
    }

    const priceTarget = card.querySelector('[data-rc-card-price]');
    const priceTemplate = findPriceTemplate(card, variantId);
    if (priceTarget && priceTemplate) {
      priceTarget.replaceChildren(priceTemplate.content.cloneNode(true));
    }

    const conditionBadge = card.querySelector('[data-rc-condition-badge]');
    if (conditionBadge) {
      const codeTarget = conditionBadge.querySelector('[data-rc-condition-code]');
      const labelTarget = conditionBadge.querySelector('[data-rc-condition-label]');

      conditionBadge.hidden = !conditionCode;
      conditionBadge.title = condition ? `Condition: ${condition}` : '';
      if (codeTarget) codeTarget.textContent = conditionCode;
      if (labelTarget) labelTarget.textContent = condition ? `Condition: ${condition}` : '';
    }
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(variantSelectSelector)) return;
    updateCardVariant(event.target);
  });
})();
